
<template>
  <div class="YearPicker">
    <div class="yearWrapper">
      <span @click="selectYear">
        {{currentYear}}
        <i class="triangle_border_down"></i>
      </span>
    </div>
    <van-popup position="bottom" v-model="show">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
        :default-index="dindex"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Picker, Popup } from "vant";

Vue.use(Picker).use(Popup);

const years = [];
for (let i = 1900; i < 2100; i++) {
  years.push(i);
}

export default {
  name: "yearPicker",
  props: ["year"],
  components: {},
  data() {
    return {
      show: false,
      currentYear: "",
      columns: years,
      dindex: 119
    };
  },
  mounted() {
    this.currentYear = this.year || new Date().getFullYear();
    
    this.dindex = years.findIndex(i => {
      return i == this.year;
    });
    console.log(this.dindex,"this.dindex")
  },
  methods: {
    onConfirm(year) {
      console.log(year);
      this.currentYear = year;
      this.$emit("yearChange", year);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    },
    selectYear() {
      this.show = true;
    }
  }
};
</script>
<style lang="stylus" scoped>

.YearPicker {
  .yearWrapper {
    text-align: center;
    font-size: 0.16rem;
    padding: 0.16rem 0 0.04rem 0;
  }

  .triangle_border_down {
    width: 0;
    height: 0;
    border-width: 5px 5px 0;
    border-style: solid;
    border-color: #2c3e50 transparent transparent;
    position: relative;
    top: 0.1rem;
    left: 0.08rem;
  }
}
</style>